var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-vertical"},[_c('detail-item',{attrs:{"name":"Event Timestamp","imgName":"circle"}},[_vm._v("\n    "+_vm._s(_vm._f("formatEpochDate")(_vm.event.timestamp,_vm.gmt))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }